import { useState } from 'react'
import { Button, Typography, Grid, Box, Stack, TextField, Divider, FormHelperText } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { passwordSearch } from "../../../api/login";
import { useConfirm } from '@components/ConfirmProvider'
import { useIsMobile } from '@/hooks/Responsive'
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function RecoverEmailAccount() {
  const { isMobile } = useIsMobile()
  const lang = useLang()
  const navigate = useNavigate();
  const { alert, confirm } = useConfirm();
  
  const [form, setForm] = useState({
    email: '',
    name: '',
    phone1: '',
    phone2: '',
    phone3: '',
  })
  const onlyDigits = (str = '') => str.replace(/[^0-9]/g, '')
  const handleChange = (e) => {
    const { name, value } = e.target
    setForm((p) => ({ 
      ...p, 
      [name]: name.includes('phone') ? onlyDigits(value) : value, 
    }))
  }
  const [errors, setErrors] = useState({ email: '', password: '' })
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validate = () => {
    let tempErrors = {};

    if (!form.name) { tempErrors.name = '이름을 입력해 주세요.'; }
    if (!form.email) { tempErrors.email = '메일을 입력해 주세요.'; }
    if (!emailRegex.test(form.email)) tempErrors.email = "이메일 형식이 올바르지 않습니다.";
    if (!form.phone1) { tempErrors.phone1 = '휴대전화번호를 입력해 주세요.'; tempErrors.phone = '휴대전화번호를 입력해 주세요.'; }
    if (!form.phone2) { tempErrors.phone2 = '휴대전화번호를 입력해 주세요.'; tempErrors.phone = '휴대전화번호를 입력해 주세요.'; }
    if (!form.phone3) { tempErrors.phone3 = '휴대전화번호를 입력해 주세요.'; tempErrors.phone = '휴대전화번호를 입력해 주세요.'; }

    setErrors(tempErrors)
    return Object.values(tempErrors).every(x => x === '')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (validate()) {
      try {
        const params = {
          memberEmail : form.email,
          memberName : form.name,
          cellphoneNo : `${form.phone1}${form.phone2}${form.phone3}`,
        };
        const response = await passwordSearch(params);

        if (response?.success) {
          navigate(buildLangHref('/recoverpasswordlater', lang), {
            state: {
              sendEmailYn: response?.data?.sendEmailYn,
            },
          });
        }
        else {
          navigate(buildLangHref('/recoverpasswordlater', lang), {
            state: {
              sendEmailYn: '',
            },
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  return (
    <Box>
      <Typography component="h3" variant={isMobile ? 'h6' : 'h5'} sx={{ mb: 1.5 }}>
        비밀번호 찾기
      </Typography>
      <Typography component="p" variant={isMobile ? 'body1' : 'subtitle2'} fontWeight={400} sx={{ mb: isMobile ? 4 : 6 }}>
        가입하신 아이디(이메일 주소)를 입력해 주세요. 해당 이메일로 임시 비밀번호를 발송해 드립니다.
      </Typography>

      <Stack>
        <Box sx={{ mb: 4 }}>
          <Typography fontWeight={500} sx={{ mb: 0.5 }}>
            아이디(이메일 주소) <Typography component="span" color="error">*</Typography>
            <Box component="span" sx={visuallyHidden}>필수 입력</Box>
          </Typography>
          <TextField 
            fullWidth 
            id="email" 
            name="email" 
            value={form.email} 
            sx={{ flex: 1 }} 
            inputProps={{ maxLength: 40 }}
            onChange={handleChange} 
            error={!!errors.email}
            helperText={errors.email}
          />
        </Box>
        <Box sx={{ mb: 4 }}>
          <Typography fontWeight={500} sx={{ mb: 0.5 }}>
            이름 <Typography component="span" color="error">*</Typography>
            <Box component="span" sx={visuallyHidden}>필수 입력</Box>
          </Typography>
          <TextField 
            fullWidth 
            id="name" 
            name="name" 
            value={form.name} 
            inputProps={{ maxLength: 30 }}
            onChange={handleChange} 
            error={!!errors.name}
            helperText={errors.name}
          />
        </Box>
        <Box sx={{ mb: 5 }}>
          <Typography fontWeight={500} sx={{ mb: 0.5 }}>
            휴대전화번호 <Typography component="span" color="error">*</Typography>
            <Box component="span" sx={visuallyHidden}>필수 입력</Box>
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1 }}>
            <TextField
              id="phone1"
              name="phone1"
              type="tel"
              value={form.phone1}
              onChange={handleChange}
              inputProps={{ inputMode: 'numeric', maxLength: 3 }}
              size="small"
              error={!!errors.phone1}
              // helperText={errors.phone1}
            />
            <Typography component="span">-</Typography>

            <TextField
              name="phone2"
              type="tel"
              value={form.phone2}
              onChange={handleChange}
              inputProps={{ inputMode: 'numeric', maxLength: 4 }}
              size="small"
              error={!!errors.phone2}
              // helperText={errors.phone2}
            />
            <Typography component="span">-</Typography>

            <TextField
              name="phone3"
              type="tel"
              value={form.phone3}
              onChange={handleChange}
              inputProps={{ inputMode: 'numeric', maxLength: 4 }}
              size="small"
              error={!!errors.phone3}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit(e)
                }
              }}
              // helperText={errors.phone3}
            />
          </Stack>
          {errors.phone && (<FormHelperText error>{errors.phone}</FormHelperText>)}
        </Box>
      </Stack>

      <Stack>
        <Button onClick={handleSubmit} size="large" variant="contained" color="primary">확인</Button>
      </Stack>
    </Box>
  )
}